// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__Cx63Q","turn-on":"Switch_turn-on__Joswz","switch-inner":"Switch_switch-inner__8Mdoz"};